import { useMutation } from '@apollo/client'
import { StyleSheet, css } from 'aphrodite'
import React, { useState, useEffect } from 'react'
import { ChevronRight } from 'react-feather'
import { useForm, Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import LayoutCol from '../../components/Layout/LayoutCol'
import UIButton from '../../components/UI/UIButton'
import UIRating from '../../components/UI/UIRating'
import UITextArea from '../../components/UI/UITextArea'
import WidgetMakerHeader from '../../components/Widget/WidgetMakerHeader'
import NOTE_REQUEST from '../../graphql/Requests/mutations/NoteRequest'
import { autoLogin } from '../../utils/Utils'
import { MEDIA_MAX_SM, MEDIA_MIN_SM } from '../../lib/breakpoints'

const styles = StyleSheet.create({
  containerForm: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '100px',
  },
  titleStyle: {
    fontSize: '32px',
    [MEDIA_MAX_SM]: {
      textAlign: 'center',
    },
  },
  descriptionStyle: {
    fontSize: '18px',
    lineHeight: '30px',
    marginBottom: 0,
  },
  subDescriptionStyle: {
    fontSize: '18px',
    lineHeight: '30px',
    margin: 0,
  },
  ratingLabel: {
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: '30px',
  },
  ratingContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '32px',
    alignItems: 'center',
    [MEDIA_MAX_SM]: {
      justifyContent: 'center',
      margin: '24px',
    },
  },
  buttonContainer: {
    marginTop: '32px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: '32px',
  },
  submitButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  nextTime: {
    alignItems: 'center',
  },
  buttonDynamicStyle: {
    height: '46px',
    alignItems: 'center',
    display: 'flex',
  },
  decriptionContainer: {
    [MEDIA_MIN_SM]: {
      maxWidth: '591px',
    },
    [MEDIA_MAX_SM]: {
      textAlign: 'center',
    },
  },
})

export default function ServiceRating() {
  const { t } = useTranslation('translation')

  const navigate = useNavigate()

  const { control, handleSubmit } = useForm({
    mode: 'all',
  })

  const [comment, setComment] = useState('')
  const [rate, setRate] = useState(0)

  const [sendRequestRate] = useMutation(NOTE_REQUEST, {
    onCompleted: () => {
      navigate('/account')
    },
    onError: () => {
      toast.error(t('pages.serviceRating.webServiceError'))
    },
  })

  const [searchParams] = useSearchParams()
  const liveId = searchParams.get('requestId')
  const challenge = searchParams.get('challenge')
  const email = searchParams.get('email')

  useEffect(() => {
    if (!challenge && !email) return
    autoLogin(challenge, email).catch(() => {
      toast.error(t('error'))
      navigate('/')
    })
  }, [challenge, email])

  const onSubmit = () => {
    sendRequestRate({
      variables: {
        id: liveId,
        comment,
        note: rate,
      },
    })
  }
  return (
    <>
      <WidgetMakerHeader
        handleBecomeMakerClick={() => {}}
        handleGlobeClick={function noRefCheck() {}}
      />
      <div className={css(styles.containerForm)}>
        <LayoutCol col={window.innerWidth > 480 ? 5 : 10}>
          <h1 className={css(styles.titleStyle)}>
            {t('pages.serviceRating.title')}
          </h1>
          <div className={css(styles.decriptionContainer)}>
            <p className={css(styles.descriptionStyle)}>
              {t('pages.serviceRating.description')}
            </p>
            <p className={css(styles.subDescriptionStyle)}>
              {t('pages.serviceRating.description2')}
            </p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Controller
              name="rate"
              control={control}
              render={() => (
                <div className={css(styles.ratingContainer)}>
                  {console.log(window.innerWidth > 480)}
                  {window.innerWidth > 480 ? (
                    <p className={css(styles.ratingLabel)}>
                      {t('pages.serviceRating.ratingLabel')}
                    </p>
                  ) : (
                    <></> // Can't make it as a simple if, I don't know why, here's the code :
                    /*
                    {
                      {window.innerWidth > 480 ? (
                        <p className={css(styles.ratingLabel)}>
                          {t('pages.serviceRating.ratingLabel')}
                        </p>
                      )}
                    */
                  )}
                  <UIRating onClick={(index) => setRate(parseInt(index) + 1)} />
                </div>
              )}
            />
            <Controller
              name="comment"
              control={control}
              render={() => (
                <UITextArea
                  onChange={(val) => setComment(val.target.value)}
                  size="small"
                  placeholder={t('pages.serviceRating.commentPlaceholder')}
                />
              )}
              rules={{
                required: {
                  value: true,
                  message: t('pages.serviceRating.commentErrorMessage'),
                },
              }}
            />
            <div className={css(styles.buttonContainer)}>
              <UIButton
                kind="text"
                dynamicStyle={styles.nextTime}
                label={t('pages.serviceRating.nextTime')}
                onClick={() => navigate('/account')}
              />
              <UIButton
                design="tertiaryLight"
                dynamicStyle={styles.buttonDynamicStyle}
                onClick={onSubmit}
                label={
                  <div className={css(styles.submitButton)}>
                    <p>{t('pages.serviceRating.submit')}</p>
                    <ChevronRight />
                  </div>
                }
              />
            </div>
          </form>
        </LayoutCol>
      </div>
    </>
  )
}
